import * as React from 'react'
import { Link } from '@ui-library/core'
import { StyledSectionContainer, HalfSectionContainer, FullSectionContainer, HalfSectionColumnContainer, ModuleContentContainer, TertiaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import { getZoneName } from '../../zone-helper'
import InfoBoxContainer from './InfoBoxContainer'
import LinkList from '../shared/LinkList'

const InfoBoxModule = ({ description, sellingPrice, rentingPrice, agencyLink, zone }) => {
  const pricesArray = [{ text: 'Prix de la vente', url: sellingPrice }, { text: 'Prix de la location', url: rentingPrice }]

  const { url } = agencyLink

  const infoContent = (
    <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
      <TertiaryTitle data-testid="tertiary-title-pp">Prix au m² de l&apos;immobilier {getZoneName(zone, 'charniereC')}</TertiaryTitle>
      <ModuleContentContainer data-testid="module-content-pp">
        {description && <InfoBoxContainer description={description} />}
        <LinkList links={pricesArray} wording={{ plural: 'prix' }} maxLings={2} />
      </ModuleContentContainer>
    </StyledSectionContainer>
  )

  const agencyContent = (
    <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
      <TertiaryTitle data-testid="tertiary-title-pp">Les agences immobilières {getZoneName(zone, 'charniereC')}</TertiaryTitle>
      <ModuleContentContainer data-testid="module-content-pp">
        <Link href={url} kind="tertiary" title="Tertiary Link">
          Voir toutes les agences {getZoneName(zone, 'charniereC')}
        </Link>
      </ModuleContentContainer>
    </StyledSectionContainer>
  )

  return (
    <>
      <HalfSectionContainer description={description} data-testid="half-section-container-pp">
        {infoContent}
        <HalfSectionColumnContainer description={description} data-testid="half-section-column-container-pp">
          {agencyContent}
          {description !== '' && <section />}
        </HalfSectionColumnContainer>
      </HalfSectionContainer>
      <FullSectionContainer data-testid="full-section-container-pp">
        {infoContent}
        {agencyContent}
      </FullSectionContainer>
    </>
  )
}

export default InfoBoxModule
